(() => {
  const root = window.Shopify?.routes?.root || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const text = window.KyoText || { added: 'Toegevoegd aan je winkelmand.', error: 'Toevoegen is niet gelukt. Probeer opnieuw.', sold: 'Uitverkocht', preview: 'Koppel eerst een Shopify-product.' };

  function toast(message) {
    const element = document.querySelector('.status-toast');
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
    clearTimeout(element._timer);
    element._timer = setTimeout(() => { element.hidden = true; }, 5000);
  }

  function showSlide(gallery, index) {
    const slides = [...gallery.querySelectorAll('[data-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== next;
      if (slideIndex !== next) slide.querySelectorAll('video').forEach(video => video.pause());
      if (slideIndex === next && !reduced.matches) slide.querySelectorAll('video').forEach(video => video.play().catch(() => {}));
    });
    thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-pressed', String(thumbIndex === next)));
    gallery.dataset.active = String(next);
  }

  function selectTab(tabs, button, focus = false) {
    tabs.querySelectorAll('[role="tab"]').forEach(tab => {
      const active = tab === button;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) button.focus();
  }

  function setPriceDisplay(form, price, compare = '', saving = '') {
    if (price) {
      form.querySelectorAll('[data-variant-price]').forEach(element => { element.textContent = price; });
      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && form === document.querySelector('[data-product-form]')) stickyPrice.textContent = price;
    }
    const compareElement = form.querySelector('[data-compare-price]');
    if (compareElement) {
      compareElement.textContent = compare || '';
      compareElement.hidden = !compare;
    }
    const savingElement = form.querySelector('[data-price-saving]');
    if (savingElement) {
      savingElement.textContent = saving || '';
      savingElement.hidden = !saving;
    }
    form.dispatchEvent(new CustomEvent('kyo:price-change', { bubbles: true, detail: { price, compare, saving } }));
  }

  function syncBundle(form, clearSubscription = true) {
    const selected = form.querySelector('[data-bundle-quantity]:checked');
    const quantity = form.querySelector('[data-product-quantity]');
    if (selected && quantity) quantity.value = selected.dataset.bundleQuantity;
    if (selected) setPriceDisplay(form, selected.dataset.bundlePrice, selected.dataset.bundleCompare, selected.dataset.bundleSaving);
    if (selected && clearSubscription) {
      const planInput = form.querySelector('[data-selling-plan]');
      if (planInput) planInput.value = '';
      form.querySelector('[data-subscription-card]')?.classList.remove('is-selected');
      form.querySelectorAll('[data-subscription-plan]').forEach(option => option.classList.remove('is-selected'));
      const trigger = form.querySelector('[data-subscription-open]');
      if (trigger) trigger.textContent = trigger.dataset.defaultLabel || 'KIES LOOPTIJD';
    }
  }

  function syncSubscription(form, option) {
    const planInput = form.querySelector('[data-selling-plan]');
    if (!planInput) return;
    planInput.value = option.dataset.subscriptionPlan || '';
    const active = Boolean(planInput.value);
    form.querySelector('[data-subscription-card]')?.classList.toggle('is-selected', active);
    if (active) {
      form.querySelectorAll('[data-bundle-quantity]').forEach(input => { input.checked = false; });
      form.querySelectorAll('[data-subscription-plan]').forEach(item => item.classList.toggle('is-selected', item === option));
      const quantity = form.querySelector('[data-product-quantity]');
      if (quantity) quantity.value = '1';
      setPriceDisplay(form, option.dataset.planPrice, option.dataset.planCompare, option.dataset.planSaving);
      const trigger = form.querySelector('[data-subscription-open]');
      if (trigger) trigger.textContent = option.dataset.planLabel || trigger.dataset.defaultLabel;
      option.closest('dialog')?.close();
    } else {
      const firstBundle = form.querySelector('[data-bundle-quantity]');
      if (firstBundle && !form.querySelector('[data-bundle-quantity]:checked')) firstBundle.checked = true;
      syncBundle(form, false);
      variantUpdate(form);
    }
  }

  function variantUpdate(form) {
    const source = form.querySelector('[data-variant-data]');
    if (!source) return;
    let variants;
    try { variants = JSON.parse(source.textContent); } catch { return; }
    const id = form.querySelector('[name="id"]')?.value;
    const variant = variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    const submit = form.querySelector('.product-submit');
    if (submit) {
      submit.disabled = !variant.available;
      submit.dataset.available = String(variant.available);
      (submit.querySelector('[data-cta-label]') || submit).textContent = variant.available ? submit.dataset.defaultLabel : text.sold;
    }
    const activePlan = form.querySelector('[data-subscription-plan].is-selected');
    const selectedBundle = form.querySelector('[data-bundle-quantity]:checked');
    if (activePlan) setPriceDisplay(form, activePlan.dataset.planPrice || variant.price_text, activePlan.dataset.planCompare, activePlan.dataset.planSaving);
    else if (selectedBundle) setPriceDisplay(form, selectedBundle.dataset.bundlePrice || variant.price_text, selectedBundle.dataset.bundleCompare, selectedBundle.dataset.bundleSaving);
    else setPriceDisplay(form, variant.price_text);
    const gallery = form.closest('[data-product-shell]')?.querySelector('[data-gallery]');
    if (gallery && variant.media_id) {
      const slide = gallery.querySelector(`[data-media-id="${variant.media_id}"]`);
      if (slide) showSlide(gallery, Number(slide.dataset.slide));
    }
    if (form.dataset.updateUrl === 'true') {
      const url = new URL(location.href);
      url.searchParams.set('variant', id);
      history.replaceState({}, '', url);
    }
  }

  async function submitProduct(form) {
    if (form.dataset.preview === 'true') { toast(text.preview); return; }
    if (!form.reportValidity()) return;
    if (!form.querySelector('[data-selling-plan]')?.value) syncBundle(form);
    const button = form.querySelector('.product-submit');
    if (!button || button.disabled) return;
    const message = form.querySelector('.form-message');
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const quantity = Number(data.get('quantity'));
    if (!id || !Number.isInteger(quantity) || quantity < 1) return;
    const item = { id, quantity };
    if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (message) message.textContent = '';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || text.error);
      if (message) message.textContent = text.added;
      toast(text.added);
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('kyo:cart-updated', { detail: cart }));
      }
    } catch (error) {
      if (message) message.textContent = error.message || text.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      variantUpdate(form);
    }
  }

  document.addEventListener('click', event => {
    const faqAll = event.target.closest('[data-faq-all]');
    if (faqAll) {
      event.preventDefault();
      faqAll.closest('.faq')?.querySelectorAll('details').forEach(detail => { detail.open = true; });
    }
    const thumb = event.target.closest('[data-thumb]');
    if (thumb) showSlide(thumb.closest('[data-gallery]'), Number(thumb.dataset.thumb));
    const tab = event.target.closest('[role="tab"]');
    if (tab) selectTab(tab.closest('[data-tabs]'), tab);
    const carousel = event.target.closest('[data-carousel-step]');
    if (carousel) {
      const track = carousel.closest('.ingredients')?.querySelector('.ingredient-track');
      track?.scrollBy({ left: track.clientWidth * Number(carousel.dataset.carouselStep), behavior: reduced.matches ? 'auto' : 'smooth' });
    }
    const videoStep = event.target.closest('[data-video-step]');
    if (videoStep) {
      const track = videoStep.closest('.testimonials')?.querySelector('[data-video-track]');
      track?.scrollBy({ left: track.clientWidth * Number(videoStep.dataset.videoStep), behavior: reduced.matches ? 'auto' : 'smooth' });
    }
    const subscriptionOpen = event.target.closest('[data-subscription-open]');
    if (subscriptionOpen) document.getElementById(subscriptionOpen.dataset.subscriptionOpen)?.showModal();
    const subscriptionClose = event.target.closest('[data-subscription-close]');
    if (subscriptionClose) subscriptionClose.closest('dialog')?.close();
    const subscriptionPlan = event.target.closest('[data-subscription-plan]');
    if (subscriptionPlan && !subscriptionPlan.disabled) {
      const form = subscriptionPlan.closest('[data-product-form]');
      if (form) syncSubscription(form, subscriptionPlan);
    }
    const stickySubmit = event.target.closest('[data-sticky-submit]');
    if (stickySubmit) document.querySelector('[data-product-form]')?.requestSubmit();
    const stickyToggle = event.target.closest('[data-sticky-toggle]');
    if (stickyToggle) {
      const sticky = stickyToggle.closest('[data-sticky-buy]');
      const collapsed = sticky.classList.toggle('is-collapsed');
      stickyToggle.setAttribute('aria-expanded', String(!collapsed));
    }
  });

  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const tabs = tab.closest('[data-tabs]');
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      let index = buttons.indexOf(tab);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      selectTab(tabs, buttons[index], true);
    }
    const thumb = event.target.closest('[data-thumb]');
    if (thumb && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
      const gallery = thumb.closest('[data-gallery]');
      showSlide(gallery, Number(thumb.dataset.thumb) + (event.key === 'ArrowRight' ? 1 : -1));
      gallery.querySelector('[aria-pressed="true"]')?.focus();
    }
  });

  document.addEventListener('change', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    if (event.target.matches('[data-bundle-quantity]')) syncBundle(form);
    if (event.target.name === 'id') variantUpdate(form);
  });

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    submitProduct(form);
  });

  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      let start = null;
      gallery.addEventListener('touchstart', event => { start = event.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', event => {
        if (start === null) return;
        const delta = event.changedTouches[0].clientX - start;
        if (Math.abs(delta) > 50) showSlide(gallery, Number(gallery.dataset.active || 0) + (delta < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      showSlide(gallery, Number(gallery.dataset.active || 0));
    });
    scope.querySelectorAll('[data-tabs]').forEach(tabs => {
      tabs.classList.add('tabs-ready');
      const selected = tabs.querySelector('[aria-selected="true"]');
      if (selected) selectTab(tabs, selected);
    });
    scope.querySelectorAll('[data-product-form]').forEach(form => { syncBundle(form); variantUpdate(form); });
    scope.querySelectorAll('[data-batch-target]').forEach(batch => {
      if (batch.dataset.batchAuto !== 'true' || !batch.dataset.batchTarget) return;
      const target = new Date(batch.dataset.batchTarget);
      if (Number.isNaN(target.getTime())) return;
      const updateBatch = () => {
        const remaining = Math.max(0, Math.ceil((target.getTime() - Date.now()) / 86400000));
        const countdown = batch.querySelector('[data-batch-countdown]');
        if (countdown) countdown.textContent = `${remaining} ${remaining === 1 ? batch.dataset.daySingular : batch.dataset.dayPlural}`;
        if (batch.dataset.batchSyncDate === 'true') {
          const date = batch.querySelector('[data-batch-current-date]');
          if (date) date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'nl', { day: 'numeric', month: 'long' }).format(target).toUpperCase();
        }
      };
      updateBatch();
      clearInterval(batch._countdownTimer);
      batch._countdownTimer = setInterval(updateBatch, 3600000);
    });
    scope.querySelectorAll('[data-sticky-buy]').forEach(sticky => {
      const submit = document.querySelector('.product-submit');
      if (!submit || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }), { threshold: 0 });
      observer.observe(submit);
    });
    if (document.body.dataset.motion !== 'false' && !reduced.matches && 'IntersectionObserver' in window) {
      document.body.classList.add('motion-enabled');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('pending'); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      scope.querySelectorAll('.reveal').forEach(element => {
        if (element.getBoundingClientRect().top > innerHeight) { element.classList.add('pending'); observer.observe(element); }
      });
    }
  }

  reduced.addEventListener('change', () => {
    document.querySelectorAll('[data-gallery]').forEach(gallery => showSlide(gallery, Number(gallery.dataset.active || 0)));
    if (reduced.matches) document.querySelectorAll('[data-gallery] video').forEach(video => video.pause());
  });

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel) {
      const button = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (button) selectTab(button.closest('[data-tabs]'), button);
    }
  });
  reduced.addEventListener('change', event => {
    if (event.matches) {
      document.body.classList.remove('motion-enabled');
      document.querySelectorAll('.pending').forEach(element => element.classList.remove('pending'));
    }
  });
  init();
})();
